export function normalizePhoneToE164(value, { defaultCountryCode = '1' } = {}) {
  const raw = String(value || '').trim();
  if (!raw) return null;
  if (raw.startsWith('+')) {
    const normalized = `+${raw.slice(1).replace(/[\s().-]/g, '')}`;
    return /^\+[1-9]\d{7,14}$/.test(normalized) ? normalized : null;
  }
  const digits = raw.replace(/\D/g, '');
  if (defaultCountryCode === '1' && digits.length === 10) return `+1${digits}`;
  if (defaultCountryCode === '1' && digits.length === 11 && digits.startsWith('1')) return `+${digits}`;
  return null;
}
